export default {"src":"/_next/static/media/30_mid.3c3e17da.svg","height":384,"width":450,"blurWidth":0,"blurHeight":0};